import React from "react";
import { Link, useParams } from "react-router-dom";
import TopBar from "../components/layout/TopBar";
import { partners } from "../data/demoData";

const pageWrap: React.CSSProperties = {
  minHeight: "100vh",
};

const container: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

const sectionCard: React.CSSProperties = {
  background: "var(--surface)",
  borderRadius: "28px",
  padding: "28px",
  border: "1px solid var(--line)",
  boxShadow: "0 18px 50px rgba(20, 20, 20, 0.06)",
};

const backLink: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  width: "fit-content",
  padding: "12px 18px",
  borderRadius: "999px",
  border: "1px solid var(--line-2)",
  background: "var(--surface-2)",
  color: "var(--text)",
  textDecoration: "none",
  fontWeight: 700,
};

const heroGrid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1.2fr) minmax(320px, 0.8fr)",
  gap: "20px",
  alignItems: "stretch",
};

const heroLeft: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "18px",
};

const badge: React.CSSProperties = {
  display: "inline-flex",
  width: "fit-content",
  padding: "8px 14px",
  borderRadius: "999px",
  background: "var(--surface-2)",
  border: "1px solid var(--line-2)",
  color: "var(--accent)",
  fontSize: "12px",
  fontWeight: 800,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
};

const title: React.CSSProperties = {
  margin: 0,
  fontSize: "42px",
  lineHeight: 1.05,
  fontWeight: 800,
  letterSpacing: "-0.04em",
  color: "var(--text)",
  fontFamily: "Montserrat",
  textTransform: "uppercase",
};

const subtitle: React.CSSProperties = {
  margin: 0,
  maxWidth: "720px",
  fontSize: "15px",
  lineHeight: 1.7,
  color: "var(--text-muted)",
};

const quickInfoWrap: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: "12px",
};

const quickInfoCard: React.CSSProperties = {
  background: "var(--surface-2)",
  border: "1px solid var(--line)",
  borderRadius: "20px",
  padding: "18px",
};

const quickInfoLabel: React.CSSProperties = {
  margin: "0 0 10px 0",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "var(--text-dim)",
};

const quickInfoValue: React.CSSProperties = {
  margin: 0,
  fontSize: "28px",
  fontWeight: 800,
  color: "var(--text)",
};

const quickInfoHint: React.CSSProperties = {
  margin: "6px 0 0 0",
  fontSize: "13px",
  color: "var(--text-muted)",
};

const rightAccentCard: React.CSSProperties = {
  height: "100%",
  minHeight: "220px",
  background: "linear-gradient(180deg, #191921 0%, #131318 100%)",
  border: "1px solid var(--line)",
  borderRadius: "24px",
  padding: "22px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const rightAccentTop: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "12px",
};

const rightAccentDot: React.CSSProperties = {
  width: "14px",
  height: "14px",
  borderRadius: "999px",
  background: "var(--accent)",
  boxShadow: "0 0 0 8px rgba(201, 243, 29, 0.14)",
};

const rightAccentTitle: React.CSSProperties = {
  margin: 0,
  fontSize: "15px",
  fontWeight: 800,
  color: "var(--text)",
};

const rightAccentText: React.CSSProperties = {
  margin: "8px 0 0 0",
  fontSize: "14px",
  lineHeight: 1.6,
  color: "var(--text-muted)",
};

const rightAccentBottom: React.CSSProperties = {
  display: "grid",
  gap: "10px",
};

const lineItem: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  paddingBottom: "10px",
  borderBottom: "1px solid var(--line)",
  fontSize: "14px",
};

const metricsGrid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "16px",
};

const metricCard: React.CSSProperties = {
  background: "var(--surface)",
  borderRadius: "22px",
  padding: "22px",
  border: "1px solid var(--line)",
  boxShadow: "0 10px 25px rgba(20, 20, 20, 0.04)",
};

const metricLabel: React.CSSProperties = {
  margin: "0 0 10px 0",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "var(--text-dim)",
};

const metricValue: React.CSSProperties = {
  margin: 0,
  fontSize: "30px",
  fontWeight: 800,
  color: "var(--text)",
};

const metricHint: React.CSSProperties = {
  margin: "6px 0 0 0",
  fontSize: "13px",
  color: "var(--text-muted)",
};

const twoColumnGrid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(320px, 0.85fr) minmax(0, 1.15fr)",
  gap: "20px",
};

const panelCard: React.CSSProperties = {
  background: "var(--surface-2)",
  border: "1px solid var(--line)",
  borderRadius: "24px",
  padding: "22px",
};

const sectionTitle: React.CSSProperties = {
  margin: "0 0 16px 0",
  fontSize: "22px",
  fontWeight: 800,
  color: "var(--text)",
  fontFamily: "Montserrat",
  textTransform: "uppercase",
};

const sectionLabel: React.CSSProperties = {
  margin: "0 0 16px 0",
  fontSize: "13px",
  fontWeight: 700,
  color: "var(--text-dim)",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const detailsList: React.CSSProperties = {
  display: "grid",
  gap: "12px",
};

const detailRow: React.CSSProperties = {
  background: "var(--surface)",
  border: "1px solid var(--line)",
  borderRadius: "18px",
  padding: "16px 18px",
  display: "flex",
  justifyContent: "space-between",
  gap: "14px",
  alignItems: "center",
};

const detailName: React.CSSProperties = {
  fontSize: "14px",
  color: "var(--text-muted)",
  fontWeight: 600,
};

const detailValue: React.CSSProperties = {
  fontSize: "15px",
  color: "var(--text)",
  fontWeight: 700,
  textAlign: "right",
};

const stockGrid: React.CSSProperties = {
  display: "grid",
  gap: "12px",
};

const stockCard: React.CSSProperties = {
  background: "var(--surface)",
  border: "1px solid var(--line)",
  borderRadius: "18px",
  padding: "16px 18px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
};

const stockName: React.CSSProperties = {
  margin: 0,
  fontSize: "15px",
  color: "var(--text)",
  fontWeight: 600,
};

const stockValue: React.CSSProperties = {
  margin: 0,
  fontSize: "14px",
  color: "var(--text-muted)",
  fontWeight: 700,
};

const purchasesWrap: React.CSSProperties = {
  background: "var(--surface)",
  borderRadius: "28px",
  padding: "24px",
  border: "1px solid var(--line)",
  boxShadow: "0 18px 50px rgba(20, 20, 20, 0.06)",
};

const purchasesHeader: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "16px",
  flexWrap: "wrap",
  marginBottom: "16px",
};

const historyButton: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "44px",
  padding: "0 18px",
  borderRadius: "999px",
  background: "var(--accent)",
  color: "var(--on-accent)",
  textDecoration: "none",
  fontWeight: 700,
  whiteSpace: "nowrap",
  boxShadow: "var(--glow)",
};

const tableWrap: React.CSSProperties = {
  width: "100%",
  overflowX: "auto",
};

const table: React.CSSProperties = {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: "620px",
};

const th: React.CSSProperties = {
  textAlign: "left",
  padding: "14px 10px",
  borderBottom: "1px solid var(--line)",
  color: "var(--text-dim)",
  fontSize: "13px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
};

const td: React.CSSProperties = {
  padding: "14px 10px",
  borderBottom: "1px solid var(--line)",
  color: "var(--text)",
  fontSize: "14px",
};

const bottomNote: React.CSSProperties = {
  paddingTop: "8px",
  color: "var(--text-dim)",
  fontSize: "12px",
  lineHeight: 1.5,
};

const statusPill = (status: string): React.CSSProperties => {
  const healthy = status === "Работает";

  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 12px",
    borderRadius: "999px",
    fontSize: "13px",
    fontWeight: 700,
    border: healthy ? "1px solid rgba(111, 227, 111, 0.28)" : "1px solid var(--line)",
    background: healthy ? "rgba(111, 227, 111, 0.10)" : "rgba(255, 92, 92, 0.10)",
    color: healthy ? "var(--ok)" : "var(--danger)",
  };
};

const PartnerDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const machine = partners.find((item) => item.id === Number(id));

  if (!machine) {
    return (
      <div className="page-shell" style={pageWrap}>
        <div className="page-container">
          <TopBar
            title="Карточка автомата"
            subtitle="Просмотр показателей, остатков и покупок по выбранному аппарату."
          />

          <div style={container}>
            <Link to="/" style={backLink}>
              ← Назад к партнёрам
            </Link>

            <div style={sectionCard}>
              <h1 style={{ ...title, fontSize: "34px" }}>Автомат не найден</h1>
              <p style={subtitle}>
                Проверь ссылку или вернись к списку партнёров и выбери автомат заново.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-shell" style={pageWrap}>
      <div className="page-container">
        <TopBar
          title="Карточка автомата"
          subtitle="Просмотр показателей, остатков и покупок по выбранному аппарату."
        />

        <div style={container}>
          <Link to="/" style={backLink}>
            ← Назад к партнёрам
          </Link>

          <div style={sectionCard}>
            <div style={heroGrid}>
              <div style={heroLeft}>
                <div>
                  <div style={badge}>БАТЯ ЗНАЕТ • Автомат</div>
                  <h1 style={title}>
                    {machine.partnerName} · {machine.machineName}
                  </h1>
                  <p style={subtitle}>
                    Здесь собрана основная информация по автомату: локация,
                    состояние, выручка, остатки и последние покупки.
                  </p>
                </div>

                <div style={quickInfoWrap}>
                  <div style={quickInfoCard}>
                    <p style={quickInfoLabel}>Локация</p>
                    <p style={{ ...quickInfoValue, fontSize: "22px" }}>
                      {machine.location}
                    </p>
                    <p style={quickInfoHint}>текущая точка установки</p>
                  </div>

                  <div style={quickInfoCard}>
                    <p style={quickInfoLabel}>Выручка</p>
                    <p style={quickInfoValue}>{machine.revenue}</p>
                    <p style={quickInfoHint}>за расчётный месяц</p>
                  </div>

                  <div style={quickInfoCard}>
                    <p style={quickInfoLabel}>Статус</p>
                    <p style={{ ...quickInfoValue, fontSize: "22px" }}>
                      {machine.status === "Работает" ? "Активен" : "Проверка"}
                    </p>
                    <p style={quickInfoHint}>состояние автомата</p>
                  </div>
                </div>
              </div>

              <div style={rightAccentCard}>
                <div style={rightAccentTop}>
                  <div>
                    <p style={rightAccentTitle}>Информация</p>
                    <p style={rightAccentText}>
                      Здесь указана вся информация о партнере, также о его автомате.
                    </p>
                  </div>

                  <div style={rightAccentDot} />
                </div>

                <div style={rightAccentBottom}>
                  <div style={lineItem}>
                    <span>Партнёр</span>
                    <strong>{machine.partnerName}</strong>
                  </div>
                  <div style={lineItem}>
                    <span>Версия</span>
                    <strong>{machine.version}</strong>
                  </div>
                  <div
                    style={{ ...lineItem, borderBottom: "none", paddingBottom: 0 }}
                  >
                    <span>ID автомата</span>
                    <strong>#{machine.id}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={metricsGrid}>
            <div style={metricCard}>
              <p style={metricLabel}>Сумма покупок</p>
              <p style={metricValue}>{machine.totalPurchases}</p>
              <p style={metricHint}>по последним данным</p>
            </div>

            <div style={metricCard}>
              <p style={metricLabel}>Покупок за день</p>
              <p style={metricValue}>{machine.dailyPurchases}</p>
              <p style={metricHint}>средний дневной объём</p>
            </div>

            <div style={metricCard}>
              <p style={metricLabel}>Средний чек</p>
              <p style={metricValue}>{machine.averageCheck}</p>
              <p style={metricHint}>по текущей конфигурации</p>
            </div>

            <div style={metricCard}>
              <p style={metricLabel}>Продажи</p>
              <p style={metricValue}>{machine.sales}</p>
              <p style={metricHint}>активность автомата</p>
            </div>
          </div>

          <div style={twoColumnGrid}>
            <div style={panelCard}>
              <p style={sectionTitle}>Основная информация</p>

              <div style={detailsList}>
                <div style={detailRow}>
                  <span style={detailName}>Партнёр</span>
                  <span style={detailValue}>{machine.partnerName}</span>
                </div>

                <div style={detailRow}>
                  <span style={detailName}>Название автомата</span>
                  <span style={detailValue}>{machine.machineName}</span>
                </div>

                <div style={detailRow}>
                  <span style={detailName}>Версия аппарата</span>
                  <span style={detailValue}>{machine.version}</span>
                </div>

                <div style={detailRow}>
                  <span style={detailName}>Способ оплаты</span>
                  <span style={detailValue}>{machine.paymentMethod}</span>
                </div>

                <div style={detailRow}>
                  <span style={detailName}>Дата пополнения</span>
                  <span style={detailValue}>{machine.refillDate}</span>
                </div>

                <div style={detailRow}>
                  <span style={detailName}>Тех. состояние</span>
                  <span style={detailValue}>{machine.health}</span>
                </div>

                <div style={detailRow}>
                  <span style={detailName}>Статус</span>
                  <span style={statusPill(machine.status)}>
                    {machine.status === "Работает" ? "Активен" : "Требует внимания"}
                  </span>
                </div>
              </div>
            </div>

            <div style={panelCard}>
              <p style={sectionTitle}>Остатки товаров</p>
              <p style={sectionLabel}>Текущие позиции</p>

              <div style={stockGrid}>
                {machine.stockItems.map((item, index) => (
                  <div key={`${item.name}-${index}`} style={stockCard}>
                    <p style={stockName}>{item.name}</p>
                    <p style={stockValue}>{item.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={purchasesWrap}>
            <div style={purchasesHeader}>
              <div>
                <h2 style={{ ...sectionTitle, marginBottom: "6px" }}>
                  Последние покупки
                </h2>
                <p style={{ ...subtitle, maxWidth: "none", fontSize: "14px" }}>
                  Показаны 6 последних операций по автомату. Полная история доступна по кнопке справа.
                </p>
              </div>

              <Link to={`/partner/${machine.id}/history`} style={historyButton}>
                Смотреть всю историю
              </Link>
            </div>

            <div style={tableWrap}>
              <table style={table}>
                <thead>
                  <tr>
                    <th style={th}>Время</th>
                    <th style={th}>Товар</th>
                    <th style={th}>Количество</th>
                    <th style={th}>Сумма</th>
                  </tr>
                </thead>

                <tbody>
                  {machine.purchases.slice(0, 6).map((item, index) => (
                    <tr key={`${item.time}-${item.toy}-${index}`}>
                      <td style={td}>{item.time}</td>
                      <td style={td}>{item.toy}</td>
                      <td style={td}>{item.qty}</td>
                      <td style={td}>{item.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div style={bottomNote}>
            Все имена и события вымышлены, любые совпадения с реальными людьми и событиями случайны.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerDetailsPage;
